import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import store from '~/store/Store';
import { Container } from '~/styles/pagesStyle';
import { handleRegisterSubMenu } from '../SubMenuServices';
import Card from './Card';

const initialForm = {
  nomeImagem: '',
};

function SubMenuCadastro() {
  const history = useHistory();
  const [form, setForm] = useState(initialForm);

  const [modulos, setModulos] = useState([{}]);
  const [menus, setMenus] = useState([{}]);
  const [parents, setParents] = useState([{}]);

  const [loading, setLoading] = useState(false);
  const [moduloSelected, setModuloSelected] = useState(false);
  const [menuSelected, setMenuSelected] = useState(false);

  useEffect(() => {
    setLoading(true);
    async function getModulesData() {
      await api
        .get('/Modulo/GetPaginado/Page/1/Length/1000')
        .then((response) => {
          setModulos(response.data.registros);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados dos módulos, recarregue a página');
          setLoading(false);
        });
    }
    getModulesData();
  }, []);

  async function handleSubmit(e) {
    if (!form.nome) {
      toast.error('Nome é obrigatório');
      return;
    }
    if (!form.descricao) {
      toast.error('Descrição é obrigatório');
      return;
    }
    if (!form.tipoPagina) {
      toast.error('Tipo de página é obrigatório');
      return;
    }
    if (!form.ordem) {
      toast.error('Ordem é obrigatório');
      return;
    }
    if (!form.idSituacaoCadastral) {
      toast.error('Situação cadastral é obrigatório');
      return;
    }
    if (!form.idRelatorio) {
      toast.error('Relatório é obrigatório');
      return;
    }
    const menuID = store.getState().SubMenu.idMenuSubMenu;
    setLoading(true);
    e.preventDefault();
    const usuarioLogado = sessionStorage.getItem('@auth/userName');
    const subMenu = {
      id: 0,
      idMenu: menuID,
      idSituacaoCadastral: form.idSituacaoCadastral,
      idPagina: null,
      nome: form.nome,
      descricao: form.descricao,
      url: form.tipoPagina === 'O' ? form.url : null,
      parent: form.parent || null,
      nomeImagem: form.nomeImagem || null,
      ordem: form.ordem,
      tipoPagina: form.tipoPagina,
      numeroGrid: 0,
      idRelatorio: form.idRelatorio,
      dataInclusao: null,
      usuario: usuarioLogado,
      excluido: false,
    };
    await handleRegisterSubMenu(subMenu, setLoading);
    history.push('/menu-sub/list');
  }

  return (
    <Container>
      <Footer />
      <Menu />
      <Card
        modulos={modulos}
        loading={loading}
        menus={menus}
        moduloSelected={moduloSelected}
        handleSubmit={handleSubmit}
        setForm={setForm}
        form={form}
        parents={parents}
        menuSelected={menuSelected}
        setLoading={setLoading}
        setMenus={setMenus}
        setModuloSelected={setModuloSelected}
        setParents={setParents}
        setMenuSelected={setMenuSelected}
      />
    </Container>
  );
}

export default SubMenuCadastro;
